import { useState } from "react";

import type { ActivatedChildComponentType } from "../BaseActivatedPanel/types";

import { StyledWrapper } from "./styles";
import type { TableActionsPanelProps } from "./types";

/*
 * @depracated use pages/sales-intelligence/common-components/table-actions-panel
 * */
const TableActionsPanel = ({ children, className }: TableActionsPanelProps) => {
    const [CurrentlyActiveChild, activateChild] = useState<ActivatedChildComponentType | null>(null);

    return (
        <StyledWrapper
            className={className}
            data-automation="table-actions-panel"
            data-automation-active={CurrentlyActiveChild !== null}
        >
            {CurrentlyActiveChild === null ? children({ activate: activateChild }) : null}
            {CurrentlyActiveChild === null ? null : <CurrentlyActiveChild onDeactivate={() => activateChild(null)} />}
        </StyledWrapper>
    );
};

export default TableActionsPanel;
